/** Room-level identity is authoritative, regardless of property management type. */
export function isPadsplitManagedRoom(room: { padsplitRoomId?: string | null }): boolean {
  return room.padsplitRoomId != null && room.padsplitRoomId !== "";
}

export const PADSPLIT_ROOM_MANAGED_MESSAGE =
  "PadSplit manages this room's type and description. The room cannot be deleted or its PadSplit ID cleared here.";
